export default __webpack_public_path__ + "static/media/icon_google_bigquery.720c1317.svg";